import React from "react";
import { Box } from "@mui/material";
import Tasks from "../components/Tasks/Tasks";
import { useDispatch } from "react-redux";
import { resetTask } from "../actions";
import NunitoText from "../components/general/NunitoText";
import ReusableButton from "../components/general/ReusableButton";
export default function AddTask() {
  document.title = "Add Task";
  const dispatch = useDispatch();
  return (
    <Box className="wrapperBox">
      <div className="firstRowContainer">
         <ReusableButton variant="ghost" text="Reset form" iconType="reset" onClick={() => dispatch(resetTask())} />
      </div>
      <div className="formContainer">
        <NunitoText
          value="Add Tasks"
          fontSize={22}
          fontWeight={650}
          
          color='var(--color-text)'
          align="left"
        />
        <Tasks />
      </div>
    </Box>
  );
}
